import React from "react";
import ShareModal from "../components/ShareModal/ShareModal";
import ReactDOM from "react-dom";
import { getDefaultFontFamily } from "../assets/store/getDefaultFontFamily";
import getCouponWidgetTheme from "../assets/store/getCouponWidgetTheme";

const renderShareModal = () => {
    const { client, drive_service_divs } = window.DriveServiceSpecials;
    const theme = getCouponWidgetTheme(drive_service_divs);
    const defaultFontFamily = getDefaultFontFamily({ fontFamily: null });

    const id = "dss-share-modal";
    const element = document.getElementById(id);

    const modalProps = {
        client,        
        defaultFontFamily,
        theme
    };

    if (element) ReactDOM.render(<ShareModal {...modalProps} />, element);
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderShareModal();
window.renderShareModal = renderShareModal;

export default renderShareModal;
